<template>
    <kgr-loading v-if="loading" />
    <div v-else>
        <div>
            <div
                class="kgr-alert kgr-alert--info kgr-row"
            >
                {{ tInfoText }}
            </div>
            <div class="kgr-row">
                <kgr-team-select
                    v-model="newRelation.team"
                    :club-id="clubId"
                />
            </div>
            <kgr-form-row
                :label="tLabelStart"
                :error="error"
                field-name="start"
            >
                <div
                    class="form-widget date-picker"
                    :class="{ invalid: (!newRelation.start || !isValidDateRange) }"
                >
                    <kgr-date-picker v-model="newRelation.start" />
                </div>
            </kgr-form-row>
            <kgr-form-row
                :label="tLabelEnd"
                :error="error"
                field-name="end"
            >
                <div
                    class="form-widget date-picker"
                    :class="{ invalid: !isValidDateRange }"
                >
                    <kgr-date-picker v-model="newRelation.end" />
                </div>
            </kgr-form-row>
            <hr class="kgr-separator" />
            <div class="kgr-row">
                <button
                    class="kgr-button"
                    @click="$emit('onClose')"
                >
                    {{ tButtonCancel }}
                </button>
                <button
                    class="kgr-button"
                    :disabled="!isValidData || !isValidDateRange"
                    :value="tButtonExecuteTestRun"
                    @click="updateTeamRelations(true)"
                >
                    {{ tButtonExecuteTestRun }}
                </button>
                <button
                    class="kgr-button kgr-button--danger"
                    :disabled="!isValidData || !isValidDateRange"
                    :value="tButtonExecute"
                    @click="updateTeamRelations(false)"
                >
                    {{ tButtonExecute }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { isBefore, parse } from '@legacy/js/date/date-fns.js';
import BatchTeamMemberRelation from './BatchTeamMemberRelation.js';
import DatePicker from '../../../../../common/form/picker/DatePicker';
import Error from '../../../../../../js/model/Error';
import FormRow from '../../../../../common/form/FormRow';
import Loading from '../../../../../common/Loading.vue';
import TeamSelect from '../../../../../common/form/select/TeamSelect';

export default {
    components: {
        'kgr-team-select': TeamSelect,
        'kgr-date-picker': DatePicker,
        'kgr-form-row': FormRow,
        'kgr-loading': Loading,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        listId: {
            type: Number,
            required: true,
        },
        entityIds: {
            type: Array,
            required: true,
        },
        entity: {
            type: String,
            required: false,
            default: 'ClubMember',
        },
        loading: {
            type: Boolean,
            required: true,
        },
        savedActionData: {
            type: Object,
            required: false,
            default: () => null,
        },
    },
    data() {
        return {
            newRelation: new BatchTeamMemberRelation(this.entity),
            error: new Error(),
        };
    },
    computed: {
        isValidDateRange() {
            if (!this.newRelation.end) {
                return true;
            }
            return isBefore(parse(this.newRelation.start, 'dd.MM.yyyy', new Date()), parse(this.newRelation.end, 'dd.MM.yyyy', new Date()));
        },
        tButtonCancel() {
            return this.$t('cancel');
        },
        isValidData() {
            return this.newRelation.isValid();
        },
        tLabelStart() {
            return this.$t('Startdatum');
        },
        tLabelEnd() {
            return this.$t('Enddatum');
        },
        tInfoText() {
            if (this.newRelation.start && this.newRelation.team) {
                return this.$t('Lists.actions.TeamAssignment.infoTextComplete', { count: this.entityIds.length, team: this.newRelation.team.name, startDate: this.newRelation.start });
            }
            return this.$t('Lists.actions.TeamAssignment.infoText', { count: this.entityIds.length });
        },
        tButtonExecute() {
            return this.$t('Ausführen');
        },
        tButtonExecuteTestRun() {
            return this.$t('Lists.actions.executeTestRun');
        },
    },
    mounted() {
        this.assignDefaultData();
    },
    updated() {
        this.assignDefaultData();
    },
    methods: {
        updateTeamRelations(isTestRun) {
            if (!this.newRelation.isValid()) {
                return;
            }
            this.$emit('executeAction', this.newRelation, isTestRun);
        },
        assignDefaultData() {
            this.newRelation.ids = this.entityIds;
            if (this.savedActionData !== null && this.savedActionData instanceof BatchTeamMemberRelation) {
                this.newRelation = this.savedActionData;
            }
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
